import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { connect } from 'react-redux';
import Button from 'react-bootstrap/lib/Button';

import { removeModal } from '../../../actions/response';
import { converter } from '../../../helpers/converter';

const classButtonInactive = 'btn btn-default close-modal btn-block';

class ModalCannotPlay extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    if (this.props.buttonCloseAction) {
      return this.props.buttonCloseAction();
    }
    this.props.removeModal('ModalCannotPlay');
  }

  onAccept(e, cb) {
    e.preventDefault();
    const scope = this;
    this.closeModal();
    return cb && cb(scope);
  }

  onClose(e, cb) {
    e.preventDefault();
    if (!cb) {
      return this.closeModal();
    }
    const scope = this;
    return cb(scope);
  }

  render() {

    const provider = this.props.provider && this.props.provider.startsWith('CV_') ? this.props.provider : this.props.provider? `CV_${this.props.provider}` : `CV_MENSUAL`;

    return (
      <Modal show>
        <Modal.Header>
          <Button
            className="close close-modal"
            onClick={e => this.onClose(e, this.props.onClose)}
          >
            x
          </Button>
          <h4 className="text-center">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className="text-center error">
          <i className="fa text-center fa-3x fa-times texto-blanco" />
          <p
            className="padding-top-2"
            dangerouslySetInnerHTML={{ __html: converter.convertApaUnicode(
              this.props.translations,
              `${provider}_unsupported_confirm_text`,
              'Este dispositivo no es compatible con el servicio que deseas contratar. Te invitamos a consultar la sección de Preguntas Frecuentes para ver dispositivos soportados.'
            ) }}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end modal_footer--button">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-5 padding-top-05">
              <Button
                className={classButtonInactive}
                onClick={e => this.onClose(e, this.props.onClose)}
              >
                {converter.convertApaUnicode(
                  this.props.translations,
                  `${provider}_unsupported_cancel_button`,
                  'Cancelar'
                )}
              </Button>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-5 padding-top-05">
              <Button
                className={classButtonInactive}
                onClick={e => this.onAccept(e, this.props.onAccept)}
              >
                {converter.convertApaUnicode(
                  this.props.translations,
                  `${provider}_unsupported_suscription_button`,
                  'Aceptar'
                )}
              </Button>
            </div>

          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
});

const mapDispatchToProps = { removeModal };

export default connect(mapStateToProps, mapDispatchToProps)(ModalCannotPlay);
